import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KnowledgeExpPageComponent } from './components/knowledge-exp-page/knowledge-exp-page.component';
import { AdminKnowledgeExpComponent } from './components/admin-knowledge-exp/admin-knowledge-exp.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: KnowledgeExpPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard],  component: AdminKnowledgeExpComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KnowledgeExpertiseRoutingModule { }
